<template>
    <div class="modal fade" id="addAutoApproveCategoryModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add a New Category</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="form-group row">
                        <label for="description" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Title</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="title" placeholder="description" v-model="data.title">
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" v-on:click="addCategory">Add Category</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                data: {
                    title: null,
                },
            }
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-auto-approve-add-category-open-modal', this.open);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('admin-auto-approve-add-category-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            addCategory() {
                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/auto-approval-system/categories", this.data, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.status)
                    if(response.status == 200) {

                        EventBus.$emit('admin-auto-approve-add-category-refresh-data');
                        $('#addAutoApproveCategoryModal').modal('toggle'); 

                    }
                });
                EventBus.$emit('admin-auto-approve-add-category-refresh-data');
            },
        }
        
    }
</script>
